var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "observer",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var handleSubmit = ref.handleSubmit
          return [
            _c(
              "b-modal",
              {
                staticClass: "ActualitesModal",
                attrs: {
                  active: _vm.open,
                  "has-modal-card": "",
                  "trap-focus": "",
                  "aria-role": "dialog",
                  "aria-label": "ActualitesModal",
                  "aria-modal": "",
                  width: "100vw"
                }
              },
              [
                [
                  _c("div", { staticClass: "modal-card" }, [
                    _c(
                      "header",
                      { staticClass: "modal-card-head" },
                      [
                        _c("H3TitleView", { staticClass: "modal-card-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("actualitesPage.manage-actualite-type")
                              ) +
                              " "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm.actualiteTypes.length > 0
                      ? _c(
                          "section",
                          { staticClass: "modal-card-body" },
                          [
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "actualitesPage.actualite-type-modal.type-list"
                                  )
                                }
                              },
                              [
                                _c(
                                  "b-select",
                                  {
                                    attrs: {
                                      expanded: "",
                                      placeholder: _vm.$t(
                                        "actualitesPage.actualite-type-modal.placeholder-type"
                                      )
                                    },
                                    model: {
                                      value: _vm.selectedActualiteType,
                                      callback: function($$v) {
                                        _vm.selectedActualiteType = $$v
                                      },
                                      expression: "selectedActualiteType"
                                    }
                                  },
                                  _vm._l(_vm.actualiteTypes, function(type) {
                                    return _c(
                                      "option",
                                      {
                                        key: type.label,
                                        staticClass: "color-option",
                                        style: {
                                          "--background-color": type.color,
                                          "--text-color":
                                            type.color === _vm.defaultColorType
                                              ? "black"
                                              : "white"
                                        },
                                        domProps: { value: type }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getActualiteTypeListLabel(
                                                type
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ],
                              1
                            ),
                            _vm.actualiteType
                              ? _c(
                                  "div",
                                  { staticClass: "mt-2" },
                                  [
                                    _c("InputWithValidation", {
                                      attrs: {
                                        type: "text",
                                        label: _vm.$t(
                                          "actualitesPage.actualite-type-modal.type-label"
                                        ),
                                        maxlength: "30",
                                        vid: "type-label",
                                        rules: "required"
                                      },
                                      on: {
                                        "manual-change": _vm.checkExistingLabel
                                      },
                                      model: {
                                        value: _vm.actualiteType.label,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.actualiteType,
                                            "label",
                                            $$v
                                          )
                                        },
                                        expression: "actualiteType.label"
                                      }
                                    }),
                                    _c(
                                      "p",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isExistingTypeLabel,
                                            expression: "isExistingTypeLabel"
                                          }
                                        ],
                                        staticClass:
                                          "help is-danger addingErrorMessage"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "actualitesPage.error-type-title"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "label",
                                      { staticClass: "label" },
                                      [
                                        _c("FormInputLabel", {
                                          attrs: {
                                            label: _vm.$t(
                                              "actualitesPage.actualite-type-modal.type-color"
                                            ),
                                            isMandatory: true
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("color-picker", {
                                      attrs: { value: _vm.selectedColor },
                                      on: { "update-value": _vm.updateColor }
                                    }),
                                    _vm.colorErrorMessage
                                      ? _c(
                                          "p",
                                          { staticClass: "help is-danger" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.colorErrorMessage)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("footer", { staticClass: "modal-card-foot" }, [
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "hoverable-discrete-link mr-3",
                              on: { click: _vm.emitCloseModale }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("close-generic")) + " "
                              )
                            ]
                          ),
                          _vm.actualiteType && _vm.actualiteType.id
                            ? _c("b-button", {
                                attrs: {
                                  label: _vm.$t("delete").toString(),
                                  type: "is-danger",
                                  rounded: "",
                                  outlined: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteType($event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _c("b-button", {
                            attrs: {
                              disabled:
                                !_vm.actualiteType ||
                                !_vm.actualiteType.label ||
                                !_vm.actualiteType.color ||
                                _vm.isExistingTypeLabel,
                              label: _vm.$t("save-generic").toString(),
                              type: "is-primary",
                              rounded: ""
                            },
                            on: {
                              click: function($event) {
                                return handleSubmit(_vm.saveType)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]
              ],
              2
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }